import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import validateTaxReturnField from '../helpers/validateTaxReturnField'
import StateSelect from '../../common/StateSelect'
import TaxFormInput from '../../common/TaxFormInput'
import TaxForm1065 from '../images/taxReturnForms/1065.png'

const ShowHide = styled.div`
  ${props => props.hide ? 'opacity: 0' : 'opacity: 1'}
`

const FormContainer = styled.form`
  position: relative;
`
const Select = styled(StateSelect)`
  position: absolute;
  left: 407px;
  top: 155px;
  font-size: 12px !important;
  height: 21px;
  padding: 0px 10px;
  background: #add6eb;
  border-radius: 3px;
  border: 1px solid #cecfcf;
  width: auto;
  margin: 0;
  &:focused {
    border: 1px solid #39c;
  }
`
const Year = styled.h1`
  position: absolute;
  top: 24px;
  left: 692px;
  font-weight: bold;
  color: #56565a;
`
const SmallYear = styled.span`
  font-weight: bold;
  font-size: 11px;
  position: absolute;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
`
const Input = styled(TaxFormInput)`
  position: absolute;
  top: 10px;
`
export default class Form1065 extends React.Component {
  static propTypes = {
    defaults:     PropTypes.object,
    onDataChange: PropTypes.func.isRequired,
    year:         PropTypes.number.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      endDate: '',
      tin: '',
      street: '',
      apt: '',
      city: '',
      state: 'default',
      zip: '',
      hide: true,
      ...props.defaults
    }
  }
  setDataChange = () => {
    const { onDataChange } = this.props
    onDataChange({
      ...this.state,
      isValid: this.validate(this.state)
    })
  } 
  showComponent = () => {
    setTimeout(()=> this.setState({hide: false}), 250)
  }
  componentDidMount() {
    // Check if defaults are valid
    this.showComponent()
    this.setDataChange()
  }
  validate = formData => {
    for (const [key, value] of Object.entries(formData)) {
      if (!validateTaxReturnField(key, value) && key !== 'apt' && key !== 'hide') {
        return false
      }
    }
    return true
  }
  onChange = (key, value) => {
    this.setState(
      { [key]: value },
      () => this.setDataChange()
    )
  }
  renderFormImage = () => {
    return <img src={TaxForm1065} />
  }
  renderFields = () => {
    const { state, tin, street, zip, apt, city, name, endDate } = this.props.defaults
    return (
      <Fragment>
        <Input
          label="Name of Partnership"
          absolute
          top={64}
          left={191}
          width={461}
          onChange={e => this.onChange('name', e.target.value)}
          required
          defaultValue={name}
          id="tax_form_name"
        />
        <Input
          top={12}
          left={527}
          width={40}
          type="shortDate"
          onChange={e => this.onChange('endDate', e.target.value)}
          required
          defaultValue={endDate}
          id="tax_form_date"
        />
        <Input
          label="Employer Identification #"
          type="ein"
          top={64}
          left={665}
          width={126}
          onChange={e => this.onChange('tin', e.target.value)}
          required
          defaultValue={tin}
          id="tax_form_ssn"
        />
        <Input
          label="Street Address"
          left={191}
          top={99}
          width={337}
          onChange={e => this.onChange('street', e.target.value)}
          required
          defaultValue={street}
          id="tax_form_street"
        />
        <Input
          label="Apt/Suite"
          left={539}
          top={99}
          width={113}
          onChange={e => this.onChange('apt', e.target.value)}
          defaultValue={apt}
          id="tax_form_apt"
        />
        <Input
          label="City"
          left={191}
          top={139}
          width={200}
          onChange={e => this.onChange('city', e.target.value)}
          required
          defaultValue={city}
          id="tax_form_city"
        />
        <Select
          onChange={e => this.onChange('state', e.target.value)}
          defaultValue={state}
          id="tax_form_state"
        />
        <Input
          label="Zip"
          type="zip"
          left={551}
          top={139}
          width={101}
          onChange={e => this.onChange('zip', e.target.value)}
          required
          defaultValue={zip}
          id="tax_form_zip"
        />
      </Fragment>
    )
  }
  renderYear = () => {
    const { year } = this.props
    return (
      <Fragment>
        <Year>{year}</Year>
        <SmallYear top={31} left={233}>{year}</SmallYear>
        <SmallYear top={31} left={395}>{year}</SmallYear>
        <SmallYear top={31} left={617}>{year}</SmallYear>
      </Fragment>
    )
  }
  render() {
    return (
      <ShowHide hide={this.state.hide}>
        <FormContainer >
          {this.renderFormImage()}
          {this.renderFields()}
          {this.renderYear()}
        </FormContainer>
      </ShowHide>
    )
  }
}